import DatePicker from './DatePicker';
import Backdrop from './Backdrop/Backdrop';
import { defaultProps } from './dataSource';

import './Picker.css';

function ModalDatePicker(props) {
    return (
        <>
            {props.isOpen && <Backdrop close={props.onCancel} />}
            <DatePicker {...props} />
        </>
    );
}

ModalDatePicker.defaultProps = defaultProps;

export default ModalDatePicker;
